'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnConfig = exports.WPReTable = exports.Popup = exports.Main = exports.Tab = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tab = require('./tab');

var _tab2 = _interopRequireDefault(_tab);

var _popup = require('./popup');

var _popup2 = _interopRequireDefault(_popup);

var _table = require('./table');

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Main = function () {
  function Main() {
    _classCallCheck(this, Main);
  }

  _createClass(Main, [{
    key: 'inform',
    value: function inform() {
      return 'This is main';
    }
  }]);

  return Main;
}();

exports.Tab = _tab2.default;
exports.Main = Main;
exports.Popup = _popup2.default;
exports.WPReTable = _table2.default;
exports.ColumnConfig = _table.ColumnConfig;